import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../../api';
import DashboardLayout from '../../../Components/Dashboard/DashboardLayout';
import './AdminSuite.css';

const AdminCoursesPage = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get('/admin/courses');
    setCourses(res.data?.data || []);
  };

  const deleteCourse = async id => {
    if (!window.confirm('Delete course?')) return;
    await api.delete(`/admin/courses/${id}`);
    toast.success('Deleted');
    load();
  };

  return (
    <DashboardLayout>
      <div className="container py-4 admin-suite">
        <div className="admin-suite-header">
          <div>
            <h3 className="admin-suite-title">Manage Courses</h3>
            <p className="admin-suite-subtitle">All courses, prices, statuses and intake counts.</p>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('/admin/courses/create')}>
            Create course
          </button>
        </div>

        <div className="admin-table-wrap admin-card">
          <div className="admin-table-head">
            <div>Course</div>
            <div>Category</div>
            <div>Price</div>
            <div>Status</div>
            <div>Actions</div>
          </div>
          {courses.map(course => (
            <div key={course.id} className="admin-table-row">
              <div>
                <strong>{course.title}</strong>
                <div className="text-muted small">
                  Intakes: {course.intakes_count ?? course.intakes?.length ?? 0}
                </div>
              </div>
              <div>{course.category}</div>
              <div>
                {course.fee_currency || 'RWF'} {course.fee}
              </div>
              <div>
                <span className={`admin-pill ${course.status}`}>{course.status}</span>
              </div>
              <div className="admin-actions">
                <button className="btn btn-sm btn-outline-primary" onClick={() => navigate(`/admin/courses/edit/${course.id}`)}>
                  Edit
                </button>
                <button className="btn btn-sm btn-outline-danger" onClick={() => deleteCourse(course.id)}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminCoursesPage;
